module.exports = __webpack_public_path__ + "img/wrapbg3.22860113.png";